import { render } from "./global-header.vue?vue&type=template&id=531c116a&ts=true&lang=pug"
import script from "./global-header.vue?vue&type=script&lang=ts&setup=true"
export * from "./global-header.vue?vue&type=script&lang=ts&setup=true"

import "./global-header.vue?vue&type=style&index=0&id=531c116a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__